import { useCallback, useEffect, useLayoutEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonSelect, CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { useNavigate } from "react-router-dom";
import { mdtAssessmentApi, useArchiveAssessmentMutation, useGetMdtAssessmentListQuery, useUpdateAssesmentStatusMutation } from "store/services/MDT/assessment";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import moment from "moment";
import { formatString, getAge, successMessageToast, userFullName } from "helpers/common";
import { useGetMdtChatterStatusQuery, useTherapistLookupQuery } from "store/services/utility";
import TableHeader from "components/shared/FormComponents/TableHeader";
import { ArchiveIcon, CalendarIcon, DeleteIcon, EditIcon, RefreshIcon, RestoreIcon, UnArchiveIcon } from "Assets/icons";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { useArchiveCaseloadMutation, useResetMdtStatusMutation, useUpdateMdtStatusMutation } from "store/services/clientCaseLoads";
import { CLIENT_TYPE_OPTIONS, SPECIALIZATION_OPTIONS, SPECIALIZATION_OPTIONS_V2 } from "config/constants";
import { SCHOOL_CLIENT_EDIT, EDIT_CHATTER_CLIENT, EDIT_HOME_EDUCATION, EDIT_PRIVATE_CLIENT } from "config/paths";
import { useArchiveClientsMutation } from "store/services/archive";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { mdtFilter } from "store/slices/filter";
import ExportButton from "components/ExportButton";
import confirmDialog from "utils/confirmationDialog";
import { schoolClientsApi, useUpdateSchoolClientMutation } from "store/services/clients/school.client";
import { useUpdateHomeEducationClientMutation } from "store/services/clients/homeEducation.client";
import TableLayoutV2 from "components/TableLayoutV2";
import { debounce } from "lodash";
import { DownArrowIcon } from "Assets/icons/V2";
import { usePersistentState } from "hooks/usePersistentState";
import confirmDialogV2 from "utils/confirmationDialogV2";

const Multidisciplinary = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.mdtFilter);

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  // const [currentPage, setCurrentPage] = useState(1);
  const [currentPage, setCurrentPage] = usePersistentState("mdt:page", 1);

  const [currentItem, setCurrentItem] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [assessmentList, setAssessmentList] = useState([]);
  const [currentEntry, setCurrentEntry] = useState(null)

  // status list
  const { data: mdtStatusList } = useGetMdtChatterStatusQuery();
  const statusList = useMemo(() => {
    // return mdtStatusList?.length
    //   ? mdtStatusList.filter(status => status?.is_default === "yes")
    //   : [];
    if (mdtStatusList?.length > 0) {
      const isDefaultOptions = mdtStatusList.filter(status => status?.is_default === "yes");
      const options = isDefaultOptions?.length > 0 ? isDefaultOptions?.map((item) => ({ label: item?.title, value: item?.id })) : [];
      return options
    }
  }, [mdtStatusList]);

  const statusList2 = useMemo(() => {
    return mdtStatusList?.length
      ? mdtStatusList.filter(status => status?.is_default === "yes")
      : [];
  }, [mdtStatusList]);

  console.log('mdtStatusList', statusList)

  const [updateAssesment, { isLoading: updateAssessmentLoading }] = useUpdateAssesmentStatusMutation();
  const [deleteMdt, { isLoading: deleteMdtLoading }] = useResetMdtStatusMutation();
  const [archiveCaseload, { isLoading: archiveCaseloadLoading }] = useArchiveCaseloadMutation();
  const [updateClient, { isLoading: updateClientLoading }] = useUpdateHomeEducationClientMutation();
  const [archiveClient, { isLoading: archiveClientLoading }] = useArchiveClientsMutation();
  const [archiveMdt, { isLoading: archiveMdtLoading }] = useArchiveAssessmentMutation()
  const [updateMdtStatus, { isLoading: updateMdtLoading }] = useUpdateMdtStatusMutation();

  const { data, isLoading, isError, isFetching, refetch } = useGetMdtAssessmentListQuery({ page: currentPage, limit: pageSize, ...filter }, { skip: !statusList });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  // Practitioner specialization options
  const specializationOptions = useMemo(() => ([
    ...Object.entries(SPECIALIZATION_OPTIONS).map(([key, label]) => ({ value: key, label }))
  ]), []);

  const handleUpdateMdtStatus = async (e, clientId) => {
    try {
      e.stopPropagation();
      const isConfirm = await confirmDialogV2({
        title: "UNASSIGN MDT",
        message: "Are you sure you want to unassign the MDT client?",
      });
      if (!isConfirm) {
        return;
      }
      let result = await updateMdtStatus({ id: clientId, type: "regular" }).unwrap();
      if (result?.error) return;

      refetch();
      successMessageToast(result?.message);
      dispatch(schoolClientsApi.util.invalidateTags(['SchoolClients']));
      dispatch(mdtAssessmentApi.util.invalidateTags(['mdtAssessmentList']));
      successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("Error updating mdt status", err);
    }
  };

  const column = [
    {
      head: "Last Name",
      accessor: "lastname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.lastname}</h6>
      ),
    },
    {
      head: "First Name",
      accessor: "firstname",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.firstname}</h6>
      ),
    },
    {
      head: "Age",
      accessor: "Age",
      isComponent: true,
      component: (item, ind) => (
        <>
          <div className="w-100 text-left">
            {item?.client_detail?.dob ?
              <div>
                {getAge(item?.client_detail?.dob)}
              </div>
              : "--"
            }
          </div>
        </>
      ),
    },
    {
      head: "Client Type",
      accessor: "ClientCategory",
      isComponent: true,
      component: (item) => formatString(item?.client_detail?.client_type)
    },
    {
      head: "Practitioner",
      accessor: "Practitioner",
      isComponent: true,
      component: (item) => formatString(item?.client_detail?.clientMdtDetail?.specialization == 'pediatrician' ? "Physician" : item?.client_detail?.clientMdtDetail?.specialization)
    },
    {
      head: "Clinic Date",
      accessor: "ClinicDate",
      isComponent: true,
      component: (item) => (
        <>{item?.client_detail?.clientMdtDetail?.clinic_date ? moment(item?.client_detail?.clientMdtDetail?.clinic_date).format("DD/MM/YYYY") : "--"}</>
      ),
    },
    {
      head: "Account Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => {
        const currentStatus = statusList?.find(x => x.value === item?.clientPendingCaseload?.mdt_status)
        return (
          <div>
            <Dropdown
              onClick={(e) => e.stopPropagation()}
            >
              <Dropdown.Toggle
                variant="transparent"
                className="p-0 border-0 text-dark w-100 d-flex align-items-center gap-0"
                id="dropdown-basic"
              >
                <p
                  style={{ width: 80, fontStyle: currentStatus?.label != "Active" && "italic" }}
                  className={`${currentStatus?.label == "Active"
                    && "greenStatus"
                    // : "redStatus"
                    } status text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-2 py-1`}
                >
                  {currentStatus?.label}
                </p>
                <DownArrowIcon />

              </Dropdown.Toggle>

              <Dropdown.Menu className="" style={{ right: 0, left: "unset", minWidth: "150px" }}>
                <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                  {statusList
                    .filter((status) =>
                      item?.clientPendingCaseload?.mdt_status != status.value
                    )
                    .map((status) => (
                      <h5
                        key={status.value}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleStatusUpdate(item)(status.value);
                        }}
                        className="cursor-pointer proxima mb-2"
                      >
                        {status.label}
                      </h5>
                    ))
                  }
                </ul>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )
      },
    },
    // {
    //   head: "Status",
    //   accessor: "Status",
    //   isComponent: true,
    //   component: (item) => (
    //     <div
    //       onClick={(e) => e.stopPropagation()}
    //     >
    //       <Dropdown onSelect={handleStatusUpdate(item)}>
    //         <Dropdown.Toggle
    //           className="border-light text-dark w-100 fw-sbold"
    //           style={{ background: "#F3F3F3", height: 40, display: "flex" }}
    //           id="dropdown-basic"
    //         >
    //           <h6> {statusList2?.find(x => x.id === item?.clientPendingCaseload?.mdt_status)?.title || "Select Status"}{" "}</h6>
    //           <span className="icn ms-2">
    //             <svg
    //               xmlns="http://www.w3.org/2000/svg"
    //               width="10"
    //               height="5"
    //               viewBox="0 0 10 5"
    //               fill="none"
    //             >
    //               <path
    //                 d="M4.99997 4.27048L0.816406 0.0869141H9.18353L4.99997 4.27048Z"
    //                 fill="#1C1B1F"
    //               />
    //             </svg>
    //           </span>
    //         </Dropdown.Toggle>
    //         <Dropdown.Menu
    //           className="w-100"
    //         >
    //           {
    //             statusList2?.map((item, index) => {
    //               return <Dropdown.Item key={index} eventKey={item.id}>{item?.title}</Dropdown.Item>
    //             })
    //           }
    //         </Dropdown.Menu>
    //       </Dropdown>
    //     </div >
    //   ),
    // },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <Dropdown
            onClick={(e) => e.stopPropagation()}
          // show={index == dropdownIndex}
          // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
          >
            <Dropdown.Toggle
              variant="transparent"
              className="p-0 border-0 text-dark w-100"
              id="dropdown-basic"
            >
              <span className="icn ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="13"
                  viewBox="0 0 28 13"
                  fill="none"
                >
                  <rect width="28" height="13" rx="6.5" fill="" />
                  <path
                    d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                    fill="#8f8f8f"
                  />
                  <path
                    d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                    fill="#8f8f8f"
                  />
                  <path
                    d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                    fill="#8f8f8f"
                  />
                </svg>
              </span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
              <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                <h5 onClick={(e) => {

                  e.stopPropagation();
                  handleEdit(item);
                }} className="cursor-pointer proxima mb-2">
                  Edit
                </h5>
                <h5 onClick={(e) => {
                  handleUpdateMdtStatus(e, item?.id);
                }} className="cursor-pointer proxima mb-2">
                  Unassign
                </h5>
                {/* <h5 onClick={(e) => {
                  e.stopPropagation()
                  setModalType(item?.clientPendingCaseload?.deletedAt ? "active" : "archive");
                  setCurrentEntry(item);
                  setShowModal(true);
                }}
                  className="cursor-pointer proxima mb-2">
                  {item?.clientPendingCaseload?.deletedAt ? "Unarchive" : "Archive"}
                </h5> */}
              </ul>
            </Dropdown.Menu>
          </Dropdown>
          {/* 
          {
            item?.status == "complete" && <div
              className="cursor-pointer d-flex align-items-center"
              style={{ padding: "10px 10px" }}
              onClick={(e) => {
                e.stopPropagation(); // prevent row navigation
                toggleRow(item.id);
              }}
            >
              {openRow === item.id ? (
                <img width={12} src={downArrow} alt="Collapse" />
              ) : (
                <img width={7} src={rightArrow} alt="Expand" />
              )}
            </div>
          } */}
        </div >
      ),
    },
    // {
    //   head: "Action",
    //   accessor: "",
    //   isComponent: true,
    //   component: (item) => (
    //     <div className="ActnBtn d-flex align-items-center  gap-10">
    //       <CommonToolTip
    //         text={"Edit"}
    //         component={<Button
    //           onClick={(e) => {

    //             e.stopPropagation();
    //             handleEdit(item);
    //           }}
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //         >
    //           <EditIcon />
    //         </Button>}
    //       />
    //       <CommonToolTip
    //         text={item?.clientPendingCaseload?.deletedAt ? "Unarchive" : "Archive"}
    //         component={<Button
    //           onClick={(e) => {
    //             e.stopPropagation()
    //             setModalType(item?.clientPendingCaseload?.deletedAt ? "active" : "archive");
    //             setCurrentEntry(item);
    //             setShowModal(true);
    //           }}
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //         >
    //           {item?.clientPendingCaseload?.deletedAt ? <><RestoreIcon /></> : <><ArchiveIcon /></>}
    //         </Button>}
    //       />
    //       {/* <Button
    //         onClick={(e) => {
    //           e.stopPropagation()
    //           setModalType(item?.clientPendingCaseload?.deletedAt ? "active" : "archive");
    //           setCurrentEntry(item);
    //           setShowModal(true);
    //         }}
    //         className="p-0 btn forteen text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
    //         variant="transparent"
    //         type="button"
    //       >
    //         <div className="d-flex gap-2 justify-content-center align-items-center">
    //           {item?.clientPendingCaseload?.deletedAt ? <><RestoreIcon />  Unarchive</> : <><ArchiveIcon /> Archive</>}
    //         </div>
    //       </Button> */}
    //       {/* <Button
    //             to={""}
    //             className="btn forteen text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
    //             onClick={handleCreate}
    //         > */}
    //       {/* <CommonToolTip
    //         text={"Delete"}
    //         component={<Button
    //           className="p-0"
    //           variant="transparent"
    //           type="button"
    //           onClick={(e) => {
    //             e.stopPropagation();
    //             handleArchiveCaseload(item.id);
    //           }}
    //         >
    //           <DeleteIcon />
    //         </Button>}
    //       /> */}
    //     </div>
    //   ),
    // },
  ];

  const handleFilterChange = (key) => (value) => {
    dispatch(mdtFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleStatusUpdate = (item) => async (status) => {
    console.log('item, status', item, status)
    try {

      const caseLoadId = item?.clientPendingCaseload?.id;
      const statusId = status;

      const result = await updateAssesment({ caseLoadId, statusId });

      if (result?.error) console.error("Error updating mdt status", result.error);
      else successMessageToast(result?.data?.message);

    } catch (error) { console.error("Error updating mdt status", error) }
  };

  const handleDelete = async () => {

    setShowModal(false);

    const list = [...assessmentList];
    const index = assessmentList?.findIndex(x => x.id === currentItem?.id);
    delete list[index];
    setAssessmentList(list.filter(Boolean));

    const result = await deleteMdt(currentItem?.id)
    if (result?.error) return;

    successMessageToast("Record has been deleted successfully.");
    refetch();
  };

  const resetFilter = () => {
    dispatch(mdtFilter({ search: "", specialization: "", status: "active", client_type: "", mdtStatus: statusList?.find((item) => item?.title == "Active")?.id, startDate: "", endDate: "", sort: { column: "id", direction: "desc" } }));
    setCurrentPage(1)
  };

  const handleEdit = (item) => {
    switch (item?.client_detail?.client_type) {

      case "home_education": navigate(EDIT_HOME_EDUCATION?.replace(":id", item?.id));
        break;

      case "school": navigate(SCHOOL_CLIENT_EDIT?.replace(":id", item?.id));
        break;

      case "private": navigate(EDIT_PRIVATE_CLIENT?.replace(":id", item?.id));
        break;

      case "chatter": navigate(EDIT_CHATTER_CLIENT?.replace(":id", item?.id));
        break;
    };
  };

  const handleArchive = async () => {

    setShowModal(false);
    let result = null;

    switch (currentItem?.client_detail?.client_type) {

      case "home_education": result = await archiveClient({ id: currentItem?.id, clientType: "home-education" });
        break;

      case "school": result = await archiveClient({ id: currentItem?.id, clientType: "school" });
        break;

      case "private": result = await archiveClient({ id: currentItem?.id, clientType: "private" });
        break;

      case "chatter": result = await archiveClient({ id: currentItem?.id, clientType: "chatter" });
        break;
    };

    if (result?.error) return;
    successMessageToast(result?.data?.message);
  };

  const handleArchiveCaseload = async (caseloadId) => {
    try {
      let isConfirm = await confirmDialog();
      if (!isConfirm) return;

      let result = await archiveCaseload(caseloadId).unwrap();
      successMessageToast(result?.data?.message);
      refetch();
    } catch (err) {
      console.error("Error archiving caseload", err);
    }
  };

  const handleArchiveMDT = async () => {
    setShowModal(false);
    const body = {
      status: currentEntry?.status == "active" ? "archived" : "active"
    }
    try {
      const result = await archiveMdt({
        id: currentEntry?.clientPendingCaseload?.id,
      });
      successMessageToast(result?.data?.message)
    } catch (err) {
      console.error("Error archiving caseload", err);
    }
  }

  const handleSearchChange = useCallback(debounce((value) => {
    setCurrentPage(1);
    handleFilterChange("search")(value);
  }, 500), [handleFilterChange, 500]);

  useLayoutEffect(() => {

    if (data?.records) setAssessmentList(data?.records)
  }, [data]);

  useEffect(() => {
    if (statusList && !filter.mdtStatus) {
      const status = statusList?.find(item => item.title === "Active");
      if (status) {
        dispatch(mdtFilter({ ...filter, mdtStatus: status.id }));
      }
    }
  }, [statusList]); // Only run when statusList changes

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDelete : handleArchiveMDT}
        type={modalType}
      />
      <section className="client position-relative py-4">
        <Container fluid={true}>
          <Col lg="12" className="my-2">
            <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
              <div className="left classroom-conslutation">
                <h6 className="m-0 fw-bold main-head themeBlue">Multidisciplinary Assessment</h6>
              </div>
              <div className="right">
              </div>
            </div>
          </Col>
          <Row className="reports-v2 my-3 d-flex justify-content-end classroom-conslutation">
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Select Practitioner</label>
                <CommonSelect
                  placeholder={"Choose one..."}
                  option={SPECIALIZATION_OPTIONS_V2}
                  onChange={(e) => handleFilterChange("specialization")(e)}
                  value={filter?.specialization}
                  // onInputChange={(val) => handleSearch(val)}
                  isFilterV2
                  isClearable
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                // isLoading={schoolsLoading}
                />
              </div>
            </Col>
            <Col md='2'>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">MDT Status</label>
                <CommonSelect
                  placeholder={"Choose one..."}
                  option={statusList}
                  onChange={(e) => handleFilterChange("mdtStatus")(e)}
                  value={filter?.mdtStatus}
                  // onInputChange={(val) => handleSearch(val)}
                  isFilterV2
                  isClearable
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                // isLoading={schoolsLoading}
                />
              </div>
            </Col>
            <Col md='3' lg="2">
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Client Type</label>
                <CommonSelect
                  placeholder={"Select"}
                  option={CLIENT_TYPE_OPTIONS?.filter((x) => x.value !== "mdt")}
                  onChange={(e) => handleFilterChange("client_type")(e)}
                  value={filter?.client_type}
                  isFilterV2
                  isClearable
                  // isLoading={schoolListLoading || schoolListFetching}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "100%", // ✅ Ensures the whole Select container is full width
                    }),
                  }}
                />
              </div>
            </Col>
            <Col lg="2">
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Start Date</label>
                <DatePicker
                  className={`input-new readonly-box h-auto search-input-filter-v2`}
                  placeholderText="Start Date"
                  selectsStart
                  icon={<CalendarIcon />}
                  showIcon
                  selected={filter?.startDate}
                  onChange={(e) => {
                    console.log(e);
                    handleFilterChange("startDate")(e)
                  }}
                />
              </div>
            </Col>
            <Col lg="2">
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">End Date</label>
                <DatePicker
                  className={`input-new readonly-box h-auto search-input-filter-v2`}
                  placeholderText="End Date"
                  selectsEnd
                  icon={<CalendarIcon />}
                  showIcon
                  selected={filter?.endDate}
                  onChange={(e) => handleFilterChange("endDate")(e)}
                />
              </div>
            </Col>
            <Col lg="2" style={{ borderLeft: "1px solid #315D99" }}>
              <div className="w-100 align-items-center gap-3">
                <label className="discharge-screen-label mb-0">Search</label>
                <input
                  onChange={(e) => handleSearchChange(e.target.value)}
                  // style={{outline: "blue"}}
                  className={`input-new readonly-box h-auto search-input-filter-v2`}
                  placeholder="Find a client..."
                  defaultValue={filter?.search}
                />
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  {/* <TableHeader
                    heading={"Multidisciplinary Assessment"}
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    filter={filter}
                    searchPlaceholder="First Name, Last Name"
                    statusOptions={[
                      { label: "All", value: "" },
                      { label: "Active", value: "active" },
                      { label: "Archived", value: "archived" }
                    ]}
                    filterComponent={
                      <>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("specialization")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {specializationOptions?.find(x => x.value == filter?.specialization)?.label || "Practitioner"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              {
                                !specializationOptions?.length ? (
                                  <Dropdown.Item disabled eventKey={null}>No Record Found</Dropdown.Item>
                                ) : specializationOptions?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.value}>{item.label}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("mdtStatus")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {statusList?.find(x => x.id == filter?.mdtStatus)?.title || "MDT Status"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              <Dropdown.Item eventKey={""}>All</Dropdown.Item>
                              {
                                !statusList?.length ? <Dropdown.Item disabled eventKey={null}>No Record Found</Dropdown.Item> : statusList?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.id}>{item?.title}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li className="">
                          <Dropdown onSelect={handleFilterChange("client_type")}>
                            <Dropdown.Toggle
                              variant="transparent"
                              className="border-0 d-flex align-items-center  justify-content-center"
                              id="dropdown-basic"
                            >
                              {CLIENT_TYPE_OPTIONS?.find(x => x.value == filter?.client_type)?.label || "Client Type"}
                              <span className="icn ms-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="12"
                                  height="8"
                                  viewBox="0 0 12 8"
                                  fill="none"
                                >
                                  <path
                                    d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                    fill="black"
                                  />
                                </svg>
                              </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu >
                              {
                                [{ label: "All", value: "" }, ...CLIENT_TYPE_OPTIONS]?.map((item, index) => {
                                  return <Dropdown.Item key={index} eventKey={item.value}>{item?.label}</Dropdown.Item>
                                })
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                        </li>
                        <li>
                          <DatePicker
                            className="form-control filter-datepicker"
                            placeholderText="Start Date"
                            selectsStart
                            icon={<CalendarIcon />}
                            showIcon
                            value={filter?.startDate ? moment(filter?.startDate).format("DD-MM-YYYY") : ""}
                            onChange={(e) => handleFilterChange("startDate")(moment(e).format("YYYY-MM-DD"))}
                          />
                        </li>
                        <li>
                          <DatePicker
                            className="form-control filter-datepicker"
                            placeholderText="End Date"
                            selectsEnd
                            icon={<CalendarIcon />}
                            showIcon
                            value={filter?.endDate ? moment(filter?.endDate).format("DD-MM-YYYY") : ""}
                            onChange={(e) => handleFilterChange("endDate")(moment(e).format("YYYY-MM-DD"))}
                          />
                        </li>
                      </>
                    }
                  /> */}
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    {/* <ExportButton
                      module={"client_mdt"}
                      filter={filter}
                    /> */}
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || updateAssessmentLoading || deleteMdtLoading || archiveClientLoading || archiveCaseloadLoading || archiveMdtLoading) && <LoadingOverlay />}
                    <TableLayoutV2
                      data={assessmentList}
                      column={column}
                      url={"/manage-mdt/multidisciplinary-assessment/detail"}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    />
                    <CstmPagination
                      totalPages={totalPages}
                      activePage={currentPage}
                      handlePageChange={handlePageChange}
                      className="paginationV2"
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Multidisciplinary;
